import { FC, useState } from 'react';
import { IMeal } from '../../../../types/camp.types';
import { Image, TouchableOpacity, View } from 'react-native';
import { Text } from '../../../../components/Text';
import { COLORS, FONTS } from '../../../../constants';
import RenderHTML from 'react-native-render-html';

export const MealItem: FC<{ meal: IMeal }> = ({ meal }) => {
  const [showContent, setShowContent] = useState<boolean>(false);
  return (
    <View
      style={{
        position: 'relative',
      }}
    >
      <TouchableOpacity
        style={{
          borderColor: '#DDDDE3',
          paddingHorizontal: 15,
          paddingVertical: 9,
          borderRadius: 16,
          borderWidth: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        onPress={() => {
          setShowContent(!showContent);
        }}
      >
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '500',
            fontSize: 16,
            color: COLORS.GREY,
          }}
        >
          {meal.name}
        </Text>
        <Image
          source={require('../../../../assets/right-arrow.png')}
          style={{
            width: 11,
            height: 11,
            tintColor: COLORS.DARK_GREY,
          }}
        />
      </TouchableOpacity>
      {showContent && meal.content && (
        <View
          style={{
            position: 'absolute',
            right: 0,
            top: 50,
          }}
        >
          <View
            style={{
              padding: 10,
              paddingTop: 0,
              paddingBottom: 0,
              shadowColor: '#000000',
              shadowOffset: {
                width: 0,
                height: 1,
              },
              shadowOpacity: 0.5,
              shadowRadius: 3,
              elevation: 3,
              backgroundColor: '#ffffff',
              borderRadius: 5,
              width: 300,
              flexDirection: 'column',
            }}
          >
            <RenderHTML
              contentWidth={300}
              source={{ html: meal.content }}
              tagsStyles={{
                body: {
                  color: COLORS.BLACK,
                  fontFamily: FONTS.AvenirMedium,
                },
              }}
            />
          </View>
        </View>
      )}
    </View>
  );
};
